'use client';

import { useAuthSession } from '@/lib/hooks/useAuth';

/**
 * Guest or signed-in player, for the home cards' layout. Until the browser's
 * auth check answers, the session cookie the server saw decides, so the server
 * HTML already has the right footer and row count.
 */
export function useVisitor(hasSession: boolean) {
  const { isAuthenticated, isLoading } = useAuthSession();
  const isSignedIn = isLoading ? hasSession : isAuthenticated;
  return { isSignedIn, isGuest: !isSignedIn };
}
